import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { declOfNum } from '../../utils/Utils'

const styles = theme => ({
  paymentFreePeriod: {
    margin: '16px 0',
    fontFamily: 'Caveat',
    fontSize: 20,
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 1,
    color: '#8866ff',
  },
})

const License = ({ classes, license }) => {
  const { type, status, daysLeft } = license

  if (type === 'TRIAL' && status === 'ACTIVE') {
    return (
      <p className={classes.paymentFreePeriod}>
        Бесплатный период. Осталось {daysLeft}{' '}
        {declOfNum(daysLeft, ['день', 'дня', 'дней'])}
      </p>
    )
  }

  return null
}

export default withStyles(styles)(License)
